import { mapGetters } from 'vuex';
import permissionKeys from '@/constants/_permissions';

/** Declaring variables to handle route changes
  * without state. so that it will not
  * get initialised more than once for each module
  * */
const rolePermission = {};
let modulePermissions = [];
let currentModule = null;

export default {
  data() {
    return {
      modulePermissions,
      currentModulePermissions: {},
      isPermissionsLoaded: this.isNotEmpty(rolePermission)
    };
  },
  computed: {
    ...mapGetters({
      rolePermissions: 'auth/getRolePermissions',
      defaultRoute: 'auth/getDefaultRoute'
    }),
    rolePermission() {
      return rolePermission;
    },
    currentModule() {
      return currentModule;
    }
  },
  watch: {
    '$route.path': 'handleRouteChange',
    rolePermissions: 'onRolePermissionsChange',
    isPermissionsLoaded: 'authorise'
  },
  methods: {
    /**
     * Handling module permissions based on logged in user role.
     * @param {*} modulePermissions => logged in user role permissions.
     */
    onRolePermissionsChange(modulePermission) {
      const { permission } = this.$route.meta;
      if (this.isNotEmpty(modulePermission)) {
        const permissions = {};
        Object.keys(modulePermission).forEach((moduleName) => {
          permissions[moduleName.toLowerCase()] = modulePermission[moduleName];
        });
        modulePermissions = permissions;
        this.modulePermissions = permissions;
        this.isPermissionsLoaded = true;
        this.authorise(permission);
        this.handlePermissionForCurrentModule();
      }
    },

    /**
     * Authorise for current logged in user to has permission
     * @param {*} module - module to authorise
     * @param {*} permission - permission to find
     */
    isUserHasPermission(permission, moduleName = currentModule) {
      permission = permission.toLowerCase();
      return modulePermissions[moduleName] ?
        (modulePermissions[moduleName][permission] || false)
        : false;
    },

    /**
     * Authorise for current logged in user to not have permission
     * @param {*} module - module to authorise
     * @param {*} permission - permission to find
     */
    isUserHasNotPermission(permission, moduleName = currentModule) {
      return !this.isUserHasPermission(permission, moduleName);
    },

    /**
     * Setting module permissions based on route path
     * @param {*} path -> expecting route path to contain moduleName
     */
    handleRouteChange() {
      const { module, permission } = this.$route.meta;
      if (module && permission && (module.toLowerCase() !== currentModule)) {
        currentModule = module.toLowerCase();
        if (this.isPermissionsLoaded) this.handlePermissionForCurrentModule();
        this.authorise(permission);
      }
    },

    /**
     * Filtering permissons based on module name.
     * @param {*} moduleName -> returns all permissions for a specific module
     */
    getPermissionsForModule(moduleName) {
      return modulePermissions[moduleName];
    },

    /**
     * Default self authorising for view on a particular module when route changes
     * Redirect to defaultRoute for a specific page based on login user role.
     */
    authorise(permission = permissionKeys.VIEW) {
      if (typeof (permission) === 'boolean') permission = permissionKeys.VIEW;
      if (this.isPermissionsLoaded) {
        if (!this.isUserHasPermission(permission.toLowerCase(), currentModule)) {
          this.$router.push({
            name: this.defaultRoute
          });
        } else {
          this.handlePermissions();
        }
      }
    },

    /**
     * Loads all permissions for a specific module.
     */
    handlePermissionForCurrentModule() {
      this.currentModulePermissions = modulePermissions[currentModule];
    },

    handlePermissions() {
      if (this.isPermissionsLoaded) {
        this.$store.dispatch('auth/setCurrentAndModulePermissions', { currentModule, modulePermissions });
      }
    }
  }
};
